var map = {
	"./add.svg": 26840,
	"./alipay.svg": 67229,
	"./arrdown.svg": 40280,
	"./arrleft.svg": 68215,
	"./arrup.svg": 41803,
	"./article-create.svg": 36988,
	"./article-ranking.svg": 4150,
	"./article.svg": 25887,
	"./audit.svg": 28404,
	"./bankcard.svg": 34887,
	"./bankcard1.svg": 28052,
	"./base-data.svg": 7129,
	"./bell.svg": 85228,
	"./binding.svg": 26498,
	"./blocked.svg": 55173,
	"./brandshop.svg": 50674,
	"./cart-down.svg": 75854,
	"./change-theme.svg": 10731,
	"./chart.svg": 50853,
	"./close.svg": 74301,
	"./cloth.svg": 51637,
	"./cloth1.svg": 70430,
	"./colapse.svg": 99648,
	"./collapse.svg": 16310,
	"./copy.svg": 49992,
	"./dashboard.svg": 90357,
	"./data-upload.svg": 36719,
	"./delete.svg": 19634,
	"./diagnosis.svg": 46910,
	"./disabled.svg": 83067,
	"./disdroy.svg": 13231,
	"./down.svg": 71979,
	"./download.svg": 85703,
	"./download2.svg": 967,
	"./edit.svg": 56943,
	"./empty.svg": 26150,
	"./error.svg": 76575,
	"./example.svg": 72143,
	"./exit-fullscreen.svg": 18471,
	"./expand.svg": 58623,
	"./expaned.svg": 34942,
	"./eye-open.svg": 68847,
	"./eye.svg": 72090,
	"./financial.svg": 23328,
	"./fullscreen.svg": 55676,
	"./getback.svg": 81852,
	"./gouxuan.svg": 95610,
	"./group.svg": 25208,
	"./guide.svg": 44909,
	"./hamburger-closed.svg": 47445,
	"./hamburger-opened.svg": 56362,
	"./histoires.svg": 90135,
	"./image.svg": 43205,
	"./info.svg": 16627,
	"./international.svg": 30965,
	"./introduce.svg": 43881,
	"./inventory.svg": 44097,
	"./language.svg": 89637,
	"./link.svg": 70127,
	"./loading.svg": 73921,
	"./medtruansfer.svg": 55289,
	"./myreg.svg": 61017,
	"./nested.svg": 56298,
	"./new.svg": 76007,
	"./next.svg": 8428,
	"./outlinepay.svg": 93687,
	"./outorder.svg": 22263,
	"./package.svg": 56045,
	"./password.svg": 14940,
	"./permission.svg": 73322,
	"./personnel-info.svg": 58682,
	"./personnel-manage.svg": 92327,
	"./personnel.svg": 95189,
	"./prev.svg": 7436,
	"./refresh.svg": 57104,
	"./require.svg": 56944,
	"./reward.svg": 28522,
	"./role.svg": 30471,
	"./save.svg": 40596,
	"./search.svg": 34103,
	"./setting.svg": 53125,
	"./setting1.svg": 94062,
	"./shared.svg": 81152,
	"./shift.svg": 84361,
	"./size.svg": 76016,
	"./size1.svg": 74321,
	"./success.svg": 88132,
	"./table.svg": 29785,
	"./tel.svg": 32242,
	"./tree.svg": 12915,
	"./up.svg": 9476,
	"./upload.svg": 38184,
	"./user.svg": 22986,
	"./video.svg": 26208,
	"./viewer.svg": 95273,
	"./warn.svg": 72327,
	"./wechat.svg": 57609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;